import { useEffect, useRef, useState } from "react";
import SimpleReactValidator from "simple-react-validator";
import { useImmer } from "use-immer";
import { successMessage, errorMessage } from "../../../utils";
import { getStampCardsSettingsApi, updateStampCardsSettingsApi } from "../api";

export const useStampCardsSettings = () => {
  const [forceUpdate, setForceUpdate] = useState(0);
  const [state, setState] = useImmer({
    isLoading: true,
    isSaving: false,
    details: {
      how_it_works: "",
      terms_and_conditions_link: "",
    },
  });

  const validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: setForceUpdate },
    }),
  );

  const fetchSettings = async () => {
    setState(draft => {
      draft.isLoading = true;
    });

    try {
      const res = await getStampCardsSettingsApi();

      if (res?.success) {
        const data = res.data || {};
        setState(draft => {
          draft.details = data;
        });
      } else if (res?.message) {
        errorMessage(res.message);
      }
    } catch (error) {
      errorMessage(error?.response?.data?.message || error.message || "Something went wrong");
    } finally {
      setState(draft => {
        draft.isLoading = false;
      });
    }
  };

  useEffect(() => {
    fetchSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState(draft => {
      draft.details[name] = value;
    });
  };

  const handleSave = async () => {
    if (!validator.current.allValid()) {
      validator.current.showMessages();
      setForceUpdate(forceUpdate + 1);
      return;
    }

    setState(draft => {
      draft.isSaving = true;
    });

    try {
      const payload = {
        how_it_works: state.details.how_it_works,
        terms_and_conditions_link: state.details.terms_and_conditions_link,
      };

      const res = await updateStampCardsSettingsApi(payload);

      if (res?.success) {
        successMessage(res.message || "Settings updated successfully");
      } else if (res?.message) {
        errorMessage(res.message);
      }
    } catch (error) {
      errorMessage(error?.response?.data?.message || error.message || "Something went wrong");
    } finally {
      setState(draft => {
        draft.isSaving = false;
      });
    }
  };

  return {
    state,
    validator,
    handleChange,
    handleSave,
  };
};
